import getConfig from 'next/config';

import client from '../utils/client';

export const loadMicroCreditsRegions = async (params?: { adsOnly?: boolean; seoActiveCitiesUrl?: string }) => {
  const { data } = await client.get(`${getConfig().publicRuntimeConfig.publicUrl}/v1/microcredit/regions/`, {
    params,
    timeout: 1500,
  });

  return data;
};
